import React from 'react';
import '../App.css';

const NotFound = (props) => {
  console.log(props);
  return <h1> Not Found </h1>;
};
export default NotFound;
